import React from "react"
import { graphql } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Jobs from "../components/Jobs/jobs"
import Hero from "../components/Hero/hero"
import Layout from "../components/Layout/layout"
import Projects from "../components/Projects/projects"
import SEO from "../components/SEO/SEO"
import Skills from "../components/Skills/skills"

import classes from "./index.module.scss"

export default ({ data }) => {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className={classes.Container}>
        <SEO siteTitle={t("pageTitle")} />
        <Hero />
        <Jobs title={t("jobsSection.title")} />
        <Skills title={t("skillsSection.title")} />
        <Projects
          projects={data.projects.nodes}
          title={t("projectsSection.title")}
        />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($language: String!) {
    projects: allStrapiProjects(
      filter: { featured: { eq: true }, hidden: { eq: false } }
      sort: { fields: strapiId, order: DESC }
    ) {
      nodes {
        id
        stack {
          id
          name
        }
        title
        web_url
        description
        description_en
        github_url
        image {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    locales: allLocale(
      filter: { ns: { in: ["index"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
